import { Modal, Card } from "@mui/material";
import "../css/Override.scss";
import { useNavigate } from "react-router-dom";
import "./AddGameModal.scss";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import GameService from "../../service/GameService";

type ModalProp = {
  open: boolean;
  handleClose: () => void;
  handleReload: () => void;
  setGameIdList: React.Dispatch<React.SetStateAction<any[]>>;
  compid: string;
  gameids: string[];
};

const AddGameModal = ({
  open,
  handleClose,
  handleReload,
  setGameIdList,
  compid,
  gameids,
}: ModalProp) => {
  const { t } = useTranslation();
  const [gameid, setGameId] = useState("");
  const [showInput, setShowInput] = useState(true);
  const [username, setUserName] = useState("");
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [selectedPolicyLists, setSelectedPolicyLists] = useState([]);
  const [debts, setDebts] = useState([]);
  const [pyi, setPYI] = useState(0.0);
  const [starScore, setStarScore] = useState([]);
  const [createAt, setCreateAt] = useState("");
  const navigate = useNavigate();

  console.log(gameids);
  const makeCompId = async () => {
    try {
      var res;
      if (gameids?.length > 0) {
        res = await GameService.updateComparison(compid, [...gameids, gameid]);
      } else {
        var arr = new Array(gameid);
        res = await GameService.createComparison(compid, arr);
      }
      console.log(res);
      if ([200, 201].includes(res.status)) {
        setGameIdList([...gameids, gameid]);
        handleReload();
      }
    } catch (error) {
      console.log(error);
    } finally {
      handleClose();
    }
  };
  const closeModal = () => {
    handleClose();
  };
  const goResult = () => {
    handleClose();
    navigate("/result", {
      state: {
        selectedGoals: selectedGoals,
        gameid: gameid,
        username: username,
        debt: debts,
        selectedPolicyLists: selectedPolicyLists,
        starScore: starScore,
        pyi: pyi,
      },
    });
  };

  const newGame = () => {
    navigate("/start");
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="addgame-modal-main"
      >
        <div className="addgame-modal-content">
          <button className="closebutton" onClick={closeModal} />
          <div className="modal-input-id-title">{t("input-gameid")}</div>
          <div className="modal-input-gameid">
            <input
              type="text"
              placeholder={t("input-gameid-here")}
              onChange={(e) => setGameId(e.target.value)}
            />
            <button onClick={makeCompId}>{t("confirm")}</button>
          </div>
          <div className="modal-newgame-title">{t("playnewgame")}</div>
          <div className="modal-new-game">
            <button onClick={newGame}>{t("newgame")}</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddGameModal;
